import { render, staticRenderFns } from "./CoreGroupbuyingsDetailInfo.vue?vue&type=template&id=9a0d440a&"
import script from "./CoreGroupbuyingsDetailInfo.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyingsDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports